import React, { useState, useEffect } from "react";
import axios from "../../helpers/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AsyncSelect from "react-select/async";

const GroupItem = (props) => {
  const [edit, setEdit] = useState(false);
  const [name, setName] = useState(props.item.name);
  const [selectedSOS, setSelectedSOS] = useState([]);

  //Style
  const customStyles = {
    multiValueLabel: (styles) => ({
      ...styles,
      whiteSpace: "pre-wrap",
    }),
    option: (styles) => ({
      ...styles,
      whiteSpace: "pre-wrap",
    }),
  };

  useEffect(() => {
    axios.get("/api/sos/").then(({ data, status }) => {
      const sos = data.results.map((row) => ({
        label: row.sos + " " + row.name,
        value: row.sos,
      }));

      const filterSOS = sos.filter((el) => props.item.sos.includes(el.value));
      setSelectedSOS(filterSOS);
    });
  }, [props.item.sos]);

  const OptionRender = ({ label, value }) => {
    if (value !== 0) {
      return label + "\n" + value;
    }
    return label;
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      const results = [];
      if (inputValue) {
        axios.get("/api/sos/autocomplete/?q=" + inputValue).then((resp) => {
          if (resp.status === 200) {
            resp.data.map((item) =>
              results.push({
                value: item.sos,
                label: item.name,
              })
            );
            resolve(results);
          }
        });
      } else {
        resolve([{ value: 0, label: "Busca sos", isDisabled: true }]);
      }
    });

  const submitHandler = () => {
    if (name && selectedSOS.length > 0) {
      const newSOS = [];
      selectedSOS.map((el) => newSOS.push(el.value));
      axios
        .put("/api/groups/" + props.item.id + "/", { name: name, sos: newSOS })
        .then((resp) => {
          console.log("Status:", resp.status);
          if (resp.status === 200) setEdit(false);
        })
        .catch((err) => {
          console.log("Error.", err);
        });
    }
  };

  return (
    <tr>
      <td style={{ padding: "15px 10px 15px 10px" }}>
        {edit ? (
          <div className="field">
            <div className="control">
              <input
                className="input"
                type="text"
                placeholder="Nombre del grupo"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
        ) : (
          <p>
            <i>{name}</i>
          </p>
        )}
      </td>
      <td style={{ padding: "15px 10px 15px 10px", maxWidth: "350px" }}>
        {edit ? (
          <div className="field" style={{ width: "100%" }}>
            <div className="control">
              <AsyncSelect
                isMulti
                cacheOptions
                defaultOptions
                loadOptions={promiseOptions}
                placeholder="Escribe el sos"
                onChange={(state) => setSelectedSOS(state)}
                value={selectedSOS}
                styles={customStyles}
                getOptionLabel={OptionRender}
              />
            </div>
          </div>
        ) : (
          <p>
            {selectedSOS.map((sos) => (
              <span className="tag is-primary mr-3" key={sos.value}>
                {sos.value}
              </span>
            ))}
          </p>
        )}
      </td>
      <td style={{ padding: "15px 10px 15px 10px" }}>
        {edit ? (
          <p className="buttons">
            <button
              className="button is-primary"
              disabled={selectedSOS.length <= 0}
              onClick={() => submitHandler()}
            >
              <span className="icon">
                <FontAwesomeIcon icon={["fas", "list-alt"]} />
              </span>
              <span>Actualizar</span>
            </button>
            <button className="button" onClick={() => setEdit(false)}>
              Cancelar
            </button>
          </p>
        ) : (
          <div className="field is-grouped">
            <div className="field mr-3 mb-0">
              <div className="control">
                <div
                  className="button is-small is-primary"
                  title="Editar"
                  onClick={() => setEdit(true)}
                >
                  <FontAwesomeIcon icon={["fas", "edit"]} />
                </div>
              </div>
            </div>
          </div>
        )}
      </td>
    </tr>
  );
};

export default GroupItem;
